import React from 'react';
import { createPortal } from 'react-dom';

const CustomAlert = ({ message, onClose }) => {
    return createPortal(
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg">
                <p className="text-gray-900">{message}</p>
                <button
                    onClick={onClose}
                    className="mt-4 bg-purple-500 text-white py-2 px-4 rounded-lg hover:bg-purple-700"
                >
                    Close
                </button>
            </div>
        </div>,
        document.body
    );
};

export const showAlert = (message) => {
    const alertContainer = document.createElement('div');
    document.body.appendChild(alertContainer);

    const handleClose = () => {
        document.body.removeChild(alertContainer);
    };

    const alertElement = (
        <CustomAlert message={message} onClose={handleClose} />
    );

    createPortal(alertElement, alertContainer);
};

export default CustomAlert;